import useSelector from './useSelector';

function useMobile(): boolean {
  const { mobile } = useSelector((state) => state.settings);
  return mobile;
}

export default useMobile;
